import {Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellIcon, SortTableCellIconColor} from '../../../../../shared/models/sort-table/cell-classes';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {NgClass} from '@angular/common';
import {TooltipDirective} from '../../../../directives/tooltip/tooltip.directive';

@Component({
  selector: 'motn-sort-table-cell-icon',
  template: `
    <div
      [attr.data-color]="color"
      (click)="onClick()"
      [motnTooltip]="$safeNavigationMigration(cell?.tooltip)"
      [tooltipShowOnClick]="false"
      [tooltipPosition]="'auto'"
      [tooltipDisabled]="!cell?.tooltip"
    >
      <i [ngClass]="iconClasses"></i>
    </div>
  `,
  styleUrls: ['./sort-table-cell-icon.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    TooltipDirective
  ],
})
export class SortTableCellIconComponent extends BaseCellComponent implements OnInit, OnChanges {
  @Input() cell: SortTableCellIcon;

  iconClasses: string[] = [];
  color: SortTableCellIconColor;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update icon and color when cell data changes
    if (changes['cell'] && this.cell) {
      this.updateIconAndColor();
    }
  }

  protected onInit(): void {
    this.updateIconAndColor();
  }

  private updateIconAndColor(): void {
    if (!this.cell) return;

    // Use fa-solid for certain icons that don't have regular versions
    const solidIcons = ['lock', 'circle-check'];
    const iconStyle = solidIcons.includes(this.cell.icon) ? 'fa-solid' : 'fa-regular';

    this.iconClasses = [iconStyle, `fa-${this.cell.icon}`, `fa-fw`];

    // Add spin animation for loader icon (matches existing spinner component)
    if (this.cell.icon === 'loader') {
      this.iconClasses.push('fa-spin');
    }


    this.color = this.cell.color;
  }

  onClick() {
    if (this.cell.clickCallback) {
      this.cell.clickCallback();
    }
  }
}
